export const SET_LOGIN_VIEW = "setLoginView";
